import { useEffect, useState } from "react";
import { CheckCircle2, Loader2, Pencil } from "lucide-react";
import Markdown from "react-markdown";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const btn = "btn-brutal px-3 py-1.5 font-display uppercase font-bold text-xs inline-flex items-center gap-1.5 disabled:opacity-50";

export default function FaqEditDialog({ entry, onClose, onSaved }) {
  const [form, setForm] = useState({ question: "", answer: "" });
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (entry) setForm({ question: entry.question || "", answer: entry.answer || "" }); }, [entry]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/admin/help/faq/${entry.id}`, form);
      toast.success("FAQ-regel bijgewerkt in de handleiding.");
      onSaved?.(); onClose();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setSaving(false);
  };

  return (
    <Dialog open={!!entry} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-2xl border-2 border-foreground rounded-none heavy-shadow max-h-[85vh] overflow-y-auto" data-testid="faq-edit-dialog">
        <DialogHeader>
          <DialogTitle className="font-display font-black uppercase tracking-tight pr-8 inline-flex items-center gap-2"><Pencil className="w-5 h-5" /> FAQ-regel bewerken</DialogTitle>
          <DialogDescription>De wijziging wordt direct doorgevoerd in het hoofdstuk <i>Veelgestelde vragen</i> van de handleiding.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <label className="block">
            <span className="font-display uppercase text-[10px] tracking-widest">Vraag</span>
            <input value={form.question} onChange={(e) => setForm({ ...form, question: e.target.value })} maxLength={300} data-testid="faq-edit-question"
              className="w-full border-2 border-foreground bg-background px-3 py-2 text-sm font-bold focus:outline-none focus:ring-2 focus:ring-primary" />
          </label>
          <label className="block">
            <span className="font-display uppercase text-[10px] tracking-widest">Antwoord (Markdown)</span>
            <textarea value={form.answer} onChange={(e) => setForm({ ...form, answer: e.target.value })} rows={5} maxLength={4000} data-testid="faq-edit-answer"
              className="w-full border-2 border-foreground bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary" />
          </label>
          <div className="border-2 border-dashed border-border p-3 text-sm" data-testid="faq-edit-preview">
            <p className="font-bold">{form.question}</p>
            <div className="prose prose-sm max-w-none"><Markdown>{form.answer}</Markdown></div>
          </div>
          <div className="flex justify-end gap-2 pt-1">
            <button onClick={onClose} className={`${btn} bg-background text-foreground`} data-testid="faq-edit-cancel">Annuleren</button>
            <button onClick={save} disabled={saving || form.question.trim().length < 3 || form.answer.trim().length < 3} className={`${btn} bg-primary text-primary-foreground`} data-testid="faq-edit-save">
              {saving ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <CheckCircle2 className="w-3.5 h-3.5" />} Opslaan
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
